'use strict';

export default {
  namespaced: true,
  state: {
    paymentModalOpen: false
  },
  mutations: {
    toggle(state) {
      state.paymentModalOpen = !state.paymentModalOpen;
    }
  },
  getters: {
    paymentModalOpen: state => {
      return state.paymentModalOpen;
    }
  }
};
